import { useState, useEffect } from 'react';

const hasObserver = 'IntersectionObserver' in window;
function useOnScreen(options) {
  const isDefaultVisible = !hasObserver;
  const [ref, setRef] = useState(null);
  const [visible, setVisible] = useState(isDefaultVisible);
  useEffect(() => {
    if (!hasObserver) {
      return () => {};
    }
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.isIntersecting);
    }, options);

    if (ref) {
      observer.observe(ref);
    }

    return () => {
      if (ref) {
        observer.unobserve(ref);
      }
    };
  }, [ref, options]);

  return [setRef, visible];
}

export default useOnScreen;
